export default function AccreditationsPartners() {
  const partners = [{
    name: "Caterpillar",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/logo_cat.png"
  }, {
    name: "Bobcat",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/logo_bobcat.png"
  }, {
    name: "John Deere",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/logo_deere.png"
  }, {
    name: "Kubota",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/logo_kubota.png"
  }, {
    name: "Case CE",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615860/img/logo_case.png"
  }];
  return <section data-section-id="126392" id="built-for-professionals" className="py-16 md:py-24 bg-background border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-center mb-12 text-2xl md:text-3xl lg:text-4xl font-black uppercase tracking-tighter text-secondary">
          The Brands You Trust, Maintained to Perfection
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-10 sm:gap-16 md:gap-20 lg:gap-24">
          {partners.map((partner, i) => <div key={i} data-index={i} className="flex items-center justify-center group">
              <img src={partner.logo} alt={`${partner.name} equipment logo`} className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale opacity-40 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100" />
            </div>)}
        </div>
      </div>
    </section>;
}